import { z } from 'zod';
import { PHONE_REGEX, isValidPhoneNumber } from './utils/phone';

export type UserRole = 'admin' | 'customer' | 'driver';
export const userRoles = ['admin', 'customer', 'driver'] as const;

export interface UserOrganization {
  organizationId: string;
  roles: UserRole[];
}

export const userZ = z.object({
  phone: z
    .string()
    .regex(PHONE_REGEX, 'Invalid phone number format. Must be +1 followed by 10 digits')
    .refine(isValidPhoneNumber, 'Please enter a valid US phone number'),
  email: z.email('Invalid email address'),
  name: z.object({
    first: z.string().min(1, 'First name must be at least 1 character'),
    last: z.string().min(1, 'Last name must be at least 1 character'),
  }),
  roles: z.array(z.enum(userRoles)),
  organizations: z.array(
    z
      .object({
        organizationId: z.string(),
        roles: z.array(z.enum(userRoles)),
      })
      .optional(),
  ),
});

export type UserZ = z.infer<typeof userZ>;
